import { AttachmentDto, DraftAttachmentDto } from "@megaron/invoices-contracts";
import { generateInvoice } from "@megaronsa/ksef-fe-invoice-converter";

export const openKsefAttachment = async (attachement: AttachmentDto | DraftAttachmentDto, ksefNumber: string) => {
  const tab = window.open("about:blank", "_blank");

  const response = await fetch(attachement.url);
  const xmlBlob = await response.blob();

  const xmlFile = new File([xmlBlob], attachement.fileName, { type: attachement.fileType });

  const pdfFile = await generateInvoice(xmlFile, { nrKSeF: ksefNumber }, "blob");

  const pdfBlob = new Blob([pdfFile], { type: "application/pdf" });

  const url = URL.createObjectURL(pdfBlob);
  if (tab) tab.location.href = url;
};
